import { get, writable } from 'svelte/store';
import type Modal from './components/Modal.svelte';
import { tick } from 'svelte';
import type { FormConfig } from '$lib/config';

export interface Address {
    street: string
    city: string
    zip: string
    state: string
}

export type ValidationResult = '' | 'submissionCheck' | 'participationCheck' | 'productCheck'

export const showLoadingBackdrop = writable(false)
export const errorModal = writable<Modal>()
export const phone = writable('' as string | null)
export const email = writable('' as string | null)
export const address = writable(null as Address | null)
export const isEmbedded = writable(false)
export const total = writable(0.0)
export const formURL = writable('')
export const eraseDealer = writable(function () { })
export const showDebug = writable(false)
export const formConfig = writable({} as FormConfig)

export const formData = (() => {
    const store = writable<{ [key: string]: string }>({});
    function setValue(key: string, value: string) {
        console.log(key, value)
        let currentData = get(store);
        if (currentData[key] == value) {
            return
        }
        store.update(currentData => {
            currentData[key] = value;
            return currentData;
        });
    }
    function setValues(values: { [key: string]: string }) {
        console.log(values)
        let currentData = get(store);
        for (let key in values) {
            if (currentData[key] == values[key]) {
                return
            }
        }
        store.update(currentData => {
            return { ...currentData, ...values };
        });
    }
    function mapValueTo(source_key: string, key: string) {
        let currentData = get(store);
        if (!currentData[source_key] || currentData[source_key] == currentData[key]) {
            return
        }
        store.update(currentData => {
            console.log(currentData);
            console.log(currentData[source_key]);
            console.log(currentData[key]);
            return currentData;
        });
    }
    function Get() {
        return get(store)
    }
    return {
        ...store,
        setValue,
        setValues,
        mapValueTo,
        get: Get
    }
})();

export const activeElement = writable(null as Element | null)
export async function setActiveElement(ev: FocusEvent): Promise<void> {
    //is it focusin or focusout?
    if (ev.type == 'focusout') {
        await new Promise(resolve => setTimeout(resolve, 0));  //We only care about focusout if it's not  followed by a focusin (example focusing to the body)
        //if it's focusout, we don't want to change the active element (even if they are focusing a different window; when they come back something will be focused in)
        //console.log('focusout:', document.activeElement)
        //return;
    }
    //console.log('focusin:', document.activeElement)
    //await new Promise(resolve => setTimeout(resolve, 0)); //We don't want the body focus unless it's a real focus event
    if (get(activeElement) == document.activeElement) {
        return;
    }
    //console.log('setting active element:', document.activeElement)
    activeElement.set(document.activeElement)
    // if (document.activeElement && document.activeElement.tagName !== 'BODY') {
    // } else {
    //     activeElement.set(document.activeElement)
    // }
}

// formData.update((value) => {

// })